declare global {
  interface Window {
    dataLayer?: Record<string, unknown>[];
  }
}

export interface FormSubmitEvent {
  insurer: string;
  tariff: string;
  insured_persons: number;
}

const FORM_SUBMIT_MANDANTS = ['sdk'];

const unique = (values: string[]) =>
  Array.from(new Set(values.filter(Boolean))).join(' | ');

export function pushFormSubmit(
  mandant: string,
  orders: SubmitEventData[],
  insuredPersons: number
) {
  if (
    !FORM_SUBMIT_MANDANTS.includes(mandant) ||
    !window.dataLayer ||
    orders.length === 0
  ) {
    return;
  }
  const event: FormSubmitEvent = {
    insurer: unique(orders.map((order) => order.insuranceName)),
    tariff: unique(orders.map((order) => order.tariffDisplayString)),
    insured_persons: insuredPersons,
  };
  window.dataLayer.push({ event: 'form_submit', ...event });
}
